// Outfits shown in the "Feel confident without the hassle" Portfolio marquee on
// the home splash page. Each entry is one card: the styled look (hero) + the
// individual garments (items), and which closet it was styled from. The piece
// count on the card derives from items.length.
export interface Look {
    closet: "her" | "his";
    hero: string;
    items: string[];
}

export const LOOKS: Look[] = [
    {
        closet: "his",
        hero: "/images/joy-new-5.png",
        items: [
            "/images/portfolio/o2-item1-1784840712536.png",
            "/images/portfolio/o2-item2-1784840717070.png",
            "/images/portfolio/o2-item3-1784840724752.avif",
            "/images/portfolio/o2-item4-1784840727518.png",
        ],
    },
    {
        closet: "her",
        hero: "/images/portfolio/o10-hero-1784908979951.png",
        items: [
            "/images/portfolio/o10-item1-1784908983478.png",
            "/images/portfolio/o10-item2-1784908986159.webp",
            "/images/portfolio/o10-item3-1784908988812.avif",
            "/images/portfolio/o10-item4-1784908991646.png",
        ],
    },
    {
        closet: "his",
        hero: "/images/portfolio/o4-hero-1784909215838.png",
        items: [
            "/images/portfolio/o4-item1-1784909221234.avif",
            "/images/portfolio/o4-item2-1784909225249.avif",
            "/images/portfolio/o4-item3-1784909227966.jpg",
            "/images/portfolio/o4-item4-1784909230554.jpg",
        ],
    },
    {
        closet: "her",
        hero: "/images/portfolio/o3-hero-1784908872838.png",
        items: [
            "/images/portfolio/o4-item1-1784909939265-0.webp",
            "/images/portfolio/o4-item2-1784909939265-1.webp",
            "/images/portfolio/o4-item3-1784909939265-2.webp",
            "/images/portfolio/o4-item4-1784909939265-3.jpg",
        ],
    },
    {
        closet: "his",
        hero: "/images/portfolio/o11-hero-1784909548032.png",
        items: [
            "/images/portfolio/o11-item1-1784909551018.png",
            "/images/portfolio/o11-item2-1784909554952.png",
            "/images/portfolio/o11-item3-1784909557621.png",
            "/images/portfolio/o11-item4-1784909559967.png",
        ],
    },
    {
        closet: "her",
        hero: "/images/joy-new-2.png",
        items: [
            "/images/portfolio/o6-item1-1784909652828.png",
            "/images/portfolio/o6-item2-1784909656651.png",
            "/images/portfolio/o6-item3-1784909658851.png",
            "/images/portfolio/o6-item4-1784909662315.webp",
        ],
    },
    {
        closet: "his",
        hero: "/images/portfolio/o11-hero-1784909394947.png",
        items: [
            "/images/portfolio/o11-item1-1784909398955.png",
            "/images/portfolio/o11-item2-1784909401810.webp",
            "/images/portfolio/o11-item3-1784909405104.png",
            "/images/portfolio/o11-item4-1784909408651.webp",
        ],
    },
    {
        closet: "her",
        hero: "/images/joy-new-3.png",
        items: [
            "/images/portfolio/o7-item1-1784909707056.png",
            "/images/portfolio/o7-item2-1784909711320.png",
            "/images/portfolio/o7-item3-1784909715788.png",
            "/images/portfolio/o7-item4-1784909721981.png",
        ],
    },
    {
        closet: "his",
        hero: "/images/portfolio/o8-hero-1784841588469.png",
        items: [
            "/images/portfolio/o8-item1-1784841591344.avif",
            "/images/portfolio/o8-item2-1784841594224.webp",
            "/images/portfolio/o8-item3-1784841597268.png",
            "/images/portfolio/o8-item4-1784841600992.png",
        ],
    },
    {
        closet: "her",
        hero: "/images/portfolio/o9-hero-1784841814982.png",
        items: [
            "/images/portfolio/o9-item1-1784841801263.avif",
            "/images/portfolio/o9-item2-1784841805292.png",
            "/images/portfolio/o9-item3-1784841809867.png",
            "/images/portfolio/o9-item4-1784841818555.avif",
        ],
    },
];
